import { render, staticRenderFns } from "./StatDoctor.vue?vue&type=template&id=f2ecd340"
import script from "./StatDoctor.vue?vue&type=script&lang=js"
export * from "./StatDoctor.vue?vue&type=script&lang=js"
import style0 from "./StatDoctor.vue?vue&type=style&index=0&id=f2ecd340&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports